module.exports = __webpack_public_path__ + "img/logo.380a7bda.png";